/**
 * MY (马来西亚) 校验规则覆写
 * 追加到默认规则数组末尾，命名规则同 diffconfig/config/validators.ts：moduleFieldName（小驼峰）
 */
export const FIELD_RULES: Record<string, any[]> = {}
